module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-a5e0172f8dd11e07ee8f5dd78aaedf27.svg";